<template>
    <div class="text-center text-sm-end text-sm-center py-0 font-14">
        <!-- Slot para acciones antes del botón principal -->
        <slot name="actions"></slot>
        <v-btn v-if="showBtn" class="text-none mr-2" rounded color="bluePrimary" dark @click="onSubmitAdd">
            {{ nameBtnAdd }}
        </v-btn>
        <!-- Slot para acciones dentro de los btn agrupados -->
        <div v-if="showBorder" class="carga-masiva mt-4 mt-lg-0">
            <span v-if="showLabel" class="carga-masiva-title">{{ labelName }}</span>
            <div class="carga-masiva-buttons">
                <v-menu v-if="showBtnDowload && downloadOptions.length" offset-y>
                    <template #activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" class="text-none ma-1 px-2" rounded outlined color="bluePrimary" :width="widthBtnDowload">
                            {{ nameBtnDownload }}
                            <v-icon right small>mdi-chevron-down</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item v-for="option in downloadOptions" :key="option.value" @click="downloadFile(option)">
                            <v-list-item-title>{{ option.text }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn v-else-if="showBtnDowload" :class="downloadButtonClass" rounded outlined color="bluePrimary" :width="widthBtnDowload" @click="downloadFile">
                    {{ nameBtnDownload }}
                </v-btn>
                <v-btn v-if="showBtnUpload" class="text-none ma-1" rounded color="bluePrimary" :width="widthBtn" dark @click="openModalFile" :disabled="disableCargar">
                    {{ nameBtnUpload }}
                </v-btn>
                <!-- Slot para acciones dentro del borde -->
                <slot name="more-actions-inside"></slot>
            </div>
        </div>
        <!-- Slot para acciones después del bloque -->
        <slot name="more-actions"></slot>
    </div>
</template>

<script>
    export default {
        props: {
            widthBtn: {
                type: String,
                default: '75px'
            },
            widthBtnDowload: {
                type: String,
                default: '160px'
            },
            nameBtnAdd: {
                type: String,
                default: 'Agregar'
            },
            showBtn: {
                type: Boolean,
                default: true
            },

            labelName: {
                type: String,
                default: 'Carga masiva'
            },
            showLabel: {
                type: Boolean,
                default: true
            },
            
            nameBtnDownload: {
                type: String,
                default: 'Descargar plantilla'
            },
            downloadButtonClass: {
                type: String,
                default: 'text-none ma-1 px-0'
            },
            showBtnDowload: {
                type: Boolean,
                default: true
            },
            downloadOptions: {
                type: Array,
                default: () => []
            },

            nameBtnUpload: {
                type: String,
                default: 'Cargar'
            },
            showBtnUpload: {
                type: Boolean,
                default: true
            },
            showBorder: {
                type: Boolean,
                default: true
            },
            disableCargar: {
                type: Boolean,
                default: false
            }
        },
        emits: ['addRegistro', 'download', 'openModalArchivo'],
        methods: {
            onSubmitAdd() {
                this.$emit('addRegistro');
            },
            downloadFile(option) {
                const value = option?.value || option;
                this.$emit('download', value);
            },
            openModalFile() {
                this.$emit('openModalArchivo');
            }
        }
    }   
</script>

<style scoped>
    .carga-masiva {
        position: relative;
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        border: 1px solid #000 !important;
        border-radius: 999px !important;
        padding: 2px 4px;
        background: white !important;
    } 
    .carga-masiva-title {
        position: absolute;
        top: -10px;
        left: 20%;
        transform: translateX(-50%);
        font-size: 11px;
        padding: 0 6px;
        background: white !important;
        color: #1C1E4D;
    }
    .carga-masiva-buttons {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .carga-masiva-buttons .v-btn.v-btn--active,
    .carga-masiva-buttons .v-btn.v-btn--active::before {
        background-color: transparent !important;
        opacity: 0 !important;
    }
    /* @media (max-width: 385px) { */
    /* @media (max-width: 465px) {
        .carga-masiva {
            border: none !important;
            padding: 0 !important;
            background: transparent !important;
            width: 100%;
        }
        .carga-masiva-title {
            display: none !important;
        }
        .carga-masiva-buttons {
            flex-direction: column;
            margin-top: 10px;
            text-align: center !important;
            align-items: center !important;
            width: 100%;
        }
        .carga-masiva-buttons > .v-btn {
            width: 100% !important;
            max-width: 100%;
            margin-left: 0 !important;
            margin-right: 0 !important;
        }
        .text-center > .v-btn {
            width: 100% !important;
            max-width: 100%;
        }
    } */
</style>
